import { FunctionComponent } from 'react';
import { DraftPlaceholderTextConfiguration, Point } from '@/types';
import { isTemplateAdminMode } from '@/utils/params';

interface Props {
  configuration: DraftPlaceholderTextConfiguration;
  isSelected: boolean;
  rotation: number;
  offset: Point;
}

export const Placeholder: FunctionComponent<Props> = ({
  configuration,
  isSelected,
  offset,
  rotation,
}) => {
  if (!isTemplateAdminMode || !isSelected) {
    return null;
  }

  const { placeholderSize, size } = configuration;

  const placeholderOffset = {
    x: offset.x + size.width / 2 - placeholderSize.width / 2,
    y: offset.y + size.height / 2 - placeholderSize.height / 2,
  };

  const placeholderRotation = `rotate(${
    rotation !== undefined ? rotation : configuration.rotation
  }, ${placeholderSize.width / 2 + placeholderOffset.x}, ${
    placeholderSize.height / 2 + placeholderOffset.y
  })`;

  return (
    <rect
      x={placeholderOffset.x}
      y={placeholderOffset.y}
      width={placeholderSize.width}
      height={placeholderSize.height}
      className="template-boundary"
      transform={placeholderRotation}
    />
  );
};
